import { h } from "preact";

import classname from "../../../../foundation/utils/classname";

import IconWindowsClose from "../../Icons/IconWindowsClose";
import IconWindowsUnmaximize from "../../Icons/IconWindowsUnmaximize";

import OnlyIconButton, { OnlyIconButtonVariant } from "../../OnlyIconButton";

import styles from "./WindowCommands.module.css";

interface Props {
    class?: string;
    onMinimize: () => void;
    onToggleMaximize: () => void;
    onClose: () => void;
    isMaximized: boolean;
}

function MinimizeLineIcon() {
    return <div class={styles.minimizeLine}/>;
}

function ToggleSquareIcon() {
    return <div class={styles.toggleSquare}/>;
}

function WindowCommands({
    class: cssClass,
    onMinimize,
    onToggleMaximize,
    onClose,
    isMaximized
}: Props) {
    return (
        <div class={classname(styles.windowCommands, cssClass)}>
            <OnlyIconButton
                variant={OnlyIconButtonVariant.Ninja}
                class={styles.minimizeOnlyIconButton}
                icon={MinimizeLineIcon}
                onClick={onMinimize}/>
            <OnlyIconButton
                variant={OnlyIconButtonVariant.Ninja}
                class={styles.toggleMaximizeOnlyIconButton}
                icon={isMaximized ? IconWindowsUnmaximize : ToggleSquareIcon}
                onClick={onToggleMaximize}/>
            <OnlyIconButton
                variant={OnlyIconButtonVariant.Ninja}
                class={styles.closeOnlyIconButton}
                icon={IconWindowsClose}
                onClick={onClose}/>
        </div>
    );
}

export default WindowCommands;
